module.exports = __webpack_public_path__ + "files/20228716f5fd19941180d363f9f32c27.png";